const CopyrightFooter = () => {

  return (
    <div className="row">
        <div className="copyright-widget text-center">
          <p className="fonts_copyright_yolo">
            &copy; {new Date().getFullYear()} by{" "}
            <a
              href="/"
              rel="noreferrer"
              style={{color:"rgb(63, 63, 63)"}}
            >
              Yolo Coliving
            </a>
            . All rights reserved.
          </p>
        </div>
      {/* End .col */}
    </div>
  );
};

export default CopyrightFooter;
